var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "no-hero g-px g-mb" }, [
    _c("div", { staticClass: "row-c-nm event-form" }, [
      _c("h2", [_vm._v(_vm._s(_vm.heading))]),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "form form--error-handling",
          attrs: { enctype: "multipart/form-data" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("div", { staticClass: "swiper-container" }, [
            _c("div", { staticClass: "swiper-wrapper" }, [
              _vm.newEntry
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "h3",
                      [_vm._t("step1-title", [_vm._v("Intentieverklaring")])],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rte mb-6" },
                      [
                        _vm._t("step1-text", [
                          _vm._v("Reveil in jouw gemeente")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "swiper-slider__btn-row" }, [
                      _c("span", [
                        _vm._v(
                          "Stap " +
                            _vm._s(_vm.slide) +
                            "/" +
                            _vm._s(_vm.totalSlides)
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--green",
                          attrs: { type: "button" },
                          on: { click: _vm.nextSlide }
                        },
                        [_vm._v("Volgende")]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [
                    _vm._t("step2-title", [
                      _vm._v("Gegevens centrale contactpersoon")
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [
                    _vm._t("step2-text", [
                      _vm._v(
                        "Voor Reveil is het handig om de coördinaten te ontvangen van de spilfiguur/centrale contactpersoon van het  Reveilmoment. Als jij dat bent, mag je gewoon jouw gegevens noteren."
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.firstNameContact.error }
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.firstNameContact.val,
                            expression: "fields.firstNameContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-first-name-contact",
                          name: "firstNameContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.firstNameContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(
                              _vm.fields.firstNameContact
                            )
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.firstNameContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.firstNameContact.error
                        ? _c("span", [
                            _vm._v("Gelieve een voornaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.lastNameContact.error }
                    },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.lastNameContact.val,
                            expression: "fields.lastNameContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-last-name-contact",
                          name: "lastNameContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.lastNameContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.lastNameContact)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.lastNameContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.lastNameContact.error
                        ? _c("span", [
                            _vm._v("Gelieve een familienaam in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.jobTitleContact.error }
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          label: "label",
                          clearable: false,
                          value: _vm.fields.jobTitleContact.val,
                          options: _vm.jobTitleOptions,
                          id: "input-job-title-contact"
                        },
                        on: { input: _vm.setJobTitleContact }
                      }),
                      _vm._v(" "),
                      _vm.fields.jobTitleContact.error
                        ? _c("span", [
                            _vm._v("Gelieve een functie te selecteren.")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.emailContact.error }
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.emailContact.val,
                            expression: "fields.emailContact.val"
                          }
                        ],
                        attrs: {
                          id: "input-email-contact",
                          name: "emailContact",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.emailContact.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorMail(_vm.fields.emailContact)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.emailContact,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.emailContact.error
                        ? _c("span", [
                            _vm._v(
                              "Gelieve een correct e-mailadres in te geven."
                            )
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "input-phone-contact" } }, [
                      _vm._v("Telefoonnummer")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.phoneContact.val,
                          expression: "fields.phoneContact.val"
                        }
                      ],
                      attrs: {
                        id: "input-phone-contact",
                        name: "phoneContact",
                        type: "text"
                      },
                      domProps: { value: _vm.fields.phoneContact.val },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.fields.phoneContact,
                            "val",
                            $event.target.value
                          )
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.city.error }
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.city.val,
                            expression: "fields.city.val"
                          }
                        ],
                        attrs: { id: "input-city", name: "city", type: "text" },
                        domProps: { value: _vm.fields.city.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.city)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.city,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.city.error
                        ? _c("span", [
                            _vm._v("Gelieve een gemeente of stad in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.zipcode.error }
                    },
                    [
                      _vm._m(5),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.zipcode.val,
                            expression: "fields.zipcode.val"
                          }
                        ],
                        attrs: {
                          id: "input-zipcode",
                          name: "zipcode",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.zipcode.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.zipcode)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.zipcode,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.zipcode.error
                        ? _c("span", [
                            _vm._v("Gelieve een postcode in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _vm.newEntry
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--rose",
                            attrs: { type: "button" },
                            on: { click: _vm.prevSlide }
                          },
                          [_vm._v("Terug")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--green",
                        attrs: { type: "button" },
                        on: { click: _vm.nextSlide }
                      },
                      [_vm._v("Volgende")]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c("h3", [_vm._t("step3-title", [_vm._v("1 November")])], 2),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step3-text")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-field-wrapper form-field-wrapper--thirds"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "form-group",
                        class: { error: _vm.fields.dateStart.error }
                      },
                      [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.fields.dateStart.val,
                              expression: "fields.dateStart.val"
                            }
                          ],
                          attrs: {
                            id: "input-date-start",
                            name: "dateStart",
                            type: "date"
                          },
                          domProps: { value: _vm.fields.dateStart.val },
                          on: {
                            change: function($event) {
                              return _vm.checkErrorReq(_vm.fields.dateStart)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.fields.dateStart,
                                "val",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.fields.dateStart.error
                          ? _c("span", [
                              _vm._v("Gelieve een datum in te geven.")
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "input-startuur" } }, [
                        _vm._v("Startuur")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.startuur.val,
                            expression: "fields.startuur.val"
                          }
                        ],
                        attrs: {
                          id: "input-startuur",
                          name: "startuur",
                          type: "time"
                        },
                        domProps: { value: _vm.fields.startuur.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.startuur,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "input-einduur" } }, [
                        _vm._v("Einduur")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.einduur.val,
                            expression: "fields.einduur.val"
                          }
                        ],
                        attrs: {
                          id: "input-einduur",
                          name: "einduur",
                          type: "time"
                        },
                        domProps: { value: _vm.fields.einduur.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.einduur,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.locationName.error }
                  },
                  [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.fields.locationName.val,
                          expression: "fields.locationName.val"
                        }
                      ],
                      attrs: {
                        id: "input-location-name",
                        name: "locationName",
                        type: "text"
                      },
                      domProps: { value: _vm.fields.locationName.val },
                      on: {
                        keyup: function($event) {
                          return _vm.checkErrorReq(_vm.fields.locationName)
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.fields.locationName,
                            "val",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.fields.locationName.error
                      ? _c("span", [_vm._v("Gelieve een naam in te geven.")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.locationStreet.error }
                    },
                    [
                      _vm._m(8),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.locationStreet.val,
                            expression: "fields.locationStreet.val"
                          }
                        ],
                        attrs: {
                          id: "input-location-street",
                          name: "locationStreet",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.locationStreet.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.locationStreet)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.locationStreet,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.locationStreet.error
                        ? _c("span", [
                            _vm._v("Gelieve een straat in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("div", { staticClass: "w-1/5" }, [
                      _c("label", { attrs: { for: "input-location-nr" } }, [
                        _vm._v("Nr")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.locationNr.val,
                            expression: "fields.locationNr.val"
                          }
                        ],
                        staticStyle: { "border-color": "#52746A" },
                        attrs: {
                          id: "input-location-nr",
                          name: "locationNr",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.locationNr.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.locationNr,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.locationZipcode.error }
                    },
                    [
                      _vm._m(9),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.locationZipcode.val,
                            expression: "fields.locationZipcode.val"
                          }
                        ],
                        attrs: {
                          id: "input-location-zipcode",
                          name: "zipcode",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.locationZipcode.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.locationZipcode)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.locationZipcode,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.locationZipcode.error
                        ? _c("span", [
                            _vm._v("Gelieve een postcode in te geven.")
                          ])
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { error: _vm.fields.locationCity.error }
                    },
                    [
                      _vm._m(10),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.locationCity.val,
                            expression: "fields.locationCity.val"
                          }
                        ],
                        attrs: {
                          id: "input-location-city",
                          name: "locationCity",
                          type: "text"
                        },
                        domProps: { value: _vm.fields.locationCity.val },
                        on: {
                          keyup: function($event) {
                            return _vm.checkErrorReq(_vm.fields.locationCity)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.locationCity,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _vm.fields.locationCity.error
                        ? _c("span", [
                            _vm._v("Gelieve een gemeente of stad in te geven.")
                          ])
                        : _vm._e()
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", [_vm._v("Omschrijf jouw evenement")]),
                    _vm._v(" "),
                    _vm._m(11),
                    _vm._v(" "),
                    _c("small", [
                      _vm._v(
                        "ENTER = nieuwe paragraaf, SHIFT+ENTER = nieuwe regel"
                      )
                    ]),
                    _vm._v(" "),
                    _c("ckeditor", {
                      attrs: { editor: _vm.editor, config: _vm.editorConfig },
                      model: {
                        value: _vm.fields.contentBlock.val,
                        callback: function($$v) {
                          _vm.$set(_vm.fields.contentBlock, "val", $$v)
                        },
                        expression: "fields.contentBlock.val"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-field-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("label", [_vm._v("Foto")]),
                      _vm._v(" "),
                      _c("file-upload", {
                        attrs: {
                          "folder-id": _vm.asset.folderId,
                          "field-id": _vm.asset.fieldId,
                          "element-id": _vm.asset.elementId,
                          "original-name": _vm.asset.originalName,
                          url: _vm.asset.url
                        },
                        on: { uploadComplete: _vm.onUploadComplete }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Links")]),
                    _vm._v(" "),
                    _c("p", { staticClass: "mb-0" }, [
                      _vm._v("Links naar jouw website of Facebook-event, ...")
                    ]),
                    _vm._v(" "),
                    _vm._m(12),
                    _vm._v(" "),
                    _c("table", { staticClass: "w-full" }, [
                      _c(
                        "tbody",
                        _vm._l(_vm.fields.externalLinks.val, function(
                          row,
                          index
                        ) {
                          return _c("tr", { key: index }, [
                            _c("td", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: row.link,
                                    expression: "row.link"
                                  }
                                ],
                                attrs: { type: "text", placeholder: "http://" },
                                domProps: { value: row.link },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(row, "link", $event.target.value)
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-right w-10" }, [
                              index > 0
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "btn btn--rose",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteRow(
                                            _vm.fields.externalLinks.val,
                                            row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Wis")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        }),
                        0
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose mt-1",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.addRow(_vm.fields.externalLinks.val, {
                              link: ""
                            })
                          }
                        }
                      },
                      [_vm._v("+ Voeg een link toe")]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "form-group",
                    class: { error: _vm.fields.eventType.error }
                  },
                  [
                    _vm._m(13),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.eventType.val,
                            expression: "fields.eventType.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-event-type-event",
                          name: "eventType",
                          type: "radio",
                          value: "event",
                          disabled: !_vm.newEntry
                        },
                        domProps: {
                          checked: _vm._q(_vm.fields.eventType.val, "event")
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.eventType,
                                "val",
                                "event"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.eventType)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { attrs: { for: "input-event-type-event" } },
                        [_vm._v("Troostconcert")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "checkbox" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.eventType.val,
                            expression: "fields.eventType.val"
                          }
                        ],
                        attrs: {
                          hidden: "",
                          id: "input-event-type-cafe",
                          name: "eventType",
                          type: "radio",
                          value: "radioReveilCafe",
                          disabled: !_vm.newEntry
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.fields.eventType.val,
                            "radioReveilCafe"
                          )
                        },
                        on: {
                          change: [
                            function($event) {
                              return _vm.$set(
                                _vm.fields.eventType,
                                "val",
                                "radioReveilCafe"
                              )
                            },
                            function($event) {
                              return _vm.checkErrorChk(_vm.fields.eventType)
                            }
                          ]
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "input-event-type-cafe" } }, [
                        _vm._v("Radio Reveil Café")
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.fields.eventType.error
                      ? _c("span", [_vm._v("Gelieve een keuze aan te duiden.")])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "swiper-slider__btn-row" }, [
                  _c("span", [
                    _vm._v(
                      "Stap " +
                        _vm._s(_vm.slide) +
                        "/" +
                        _vm._s(_vm.totalSlides)
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn--rose",
                        attrs: { type: "button" },
                        on: { click: _vm.prevSlide }
                      },
                      [_vm._v("Terug")]
                    ),
                    _vm._v(" "),
                    _vm.newEntry || !_vm.isCafe
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: { type: "button" },
                            on: { click: _vm.nextSlide }
                          },
                          [_vm._v("Volgende")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.newEntry && _vm.isCafe
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: {
                              type: "button",
                              disabled: _vm.disableSubmit
                            },
                            on: { click: _vm.submitCafeEdit }
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.disableSubmit,
                                    expression: "!disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Verzenden")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.disableSubmit,
                                    expression: "disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Even geduld")]
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "swiper-slide" },
                [
                  _c("h3", [_vm._t("step4-title", [_vm._v("Bestellen")])], 2),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "rte mb-16" },
                    [_vm._t("step4-text")],
                    2
                  ),
                  _vm._v(" "),
                  _vm.fields.orderHistory.val
                    ? _c("div", [
                        _c("h3", [_vm._v("Reeds besteld")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "rte mb-16" }, [
                          _c("p", [
                            _vm._v(
                              "Je kan eventueel nog extra items bijbestellen."
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(_vm.fields.orderHistory.val)
                            }
                          })
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.articles, function(group) {
                    return _c("div", { staticClass: "mb-16" }, [
                      _c("h3", [_vm._v(_vm._s(group.title))]),
                      _vm._v(" "),
                      group.image
                        ? _c("img", {
                            staticClass: "w-full mb-6",
                            attrs: { src: group.image, alt: "" }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "rte mb-6",
                        domProps: { innerHTML: _vm._s(group.text) }
                      }),
                      _vm._v(" "),
                      group.type == "radiobuttons"
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _vm._l(group.items, function(item) {
                                return _c("div", { staticClass: "checkbox" }, [
                                  _c("input", {
                                    ref: group.groupSlug + "-" + item.itemSlug,
                                    refInFor: true,
                                    attrs: {
                                      hidden: "",
                                      type: "radio",
                                      id: group.groupSlug + "-" + item.itemSlug,
                                      name: group.groupSlug
                                    },
                                    domProps: { value: item.item },
                                    on: {
                                      change: function($event) {
                                        return _vm.setLineItem(
                                          group.type,
                                          group.groupSlug,
                                          item.itemSlug,
                                          group.title,
                                          item.item
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          group.groupSlug + "-" + item.itemSlug
                                      }
                                    },
                                    [_vm._v(_vm._s(item.item))]
                                  )
                                ])
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "checkbox" }, [
                                _c("input", {
                                  ref: group.groupSlug + "-nee-bedankt",
                                  refInFor: true,
                                  attrs: {
                                    hidden: "",
                                    type: "radio",
                                    id: group.groupSlug,
                                    name: group.groupSlug,
                                    value: "Nee bedankt"
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.setLineItem(
                                        group.type,
                                        group.groupSlug,
                                        "nee-bedankt",
                                        group.title,
                                        "Nee bedankt"
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  { attrs: { for: group.groupSlug } },
                                  [
                                    _vm._v(
                                      "Nee bedankt, niet nodig voor mijn gemeente"
                                    )
                                  ]
                                )
                              ])
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      group.type == "checkboxes"
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            _vm._l(group.items, function(item) {
                              return _c(
                                "div",
                                { staticClass: "checkbox checkbox--square" },
                                [
                                  _c("input", {
                                    ref: group.groupSlug + "-" + item.itemSlug,
                                    refInFor: true,
                                    attrs: {
                                      hidden: "",
                                      type: "checkbox",
                                      id: group.groupSlug + "-" + item.itemSlug
                                    },
                                    domProps: { value: item.item },
                                    on: {
                                      change: function($event) {
                                        return _vm.setLineItem(
                                          group.type,
                                          group.groupSlug,
                                          item.itemSlug,
                                          group.title,
                                          item.item
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          group.groupSlug + "-" + item.itemSlug
                                      }
                                    },
                                    [_vm._v(_vm._s(item.item))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      group.type == "aantallen"
                        ? _c(
                            "div",
                            { staticClass: "form-group" },
                            _vm._l(group.items, function(item) {
                              return _c(
                                "div",
                                { staticClass: "input input--number" },
                                [
                                  _c("input", {
                                    ref: group.groupSlug + "-" + item.itemSlug,
                                    refInFor: true,
                                    attrs: {
                                      type: "number",
                                      id: group.groupSlug + "-" + item.itemSlug,
                                      name: group.groupSlug,
                                      value: "",
                                      placeholder: "0",
                                      min: "0"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.setLineItem(
                                          group.type,
                                          group.groupSlug,
                                          item.itemSlug,
                                          group.title,
                                          item.item
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          group.groupSlug + "-" + item.itemSlug
                                      }
                                    },
                                    [_vm._v(_vm._s(item.item))]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ])
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.orderActive,
                          expression: "orderActive"
                        }
                      ]
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { error: _vm.fields.shippingAddress.error }
                        },
                        [
                          _vm._m(14),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.shippingAddress.val,
                                expression: "fields.shippingAddress.val"
                              }
                            ],
                            attrs: {
                              id: "input-shipping-address",
                              name: "shippingAddress",
                              rows: "3"
                            },
                            domProps: { value: _vm.fields.shippingAddress.val },
                            on: {
                              keyup: function($event) {
                                return _vm.checkErrorReq(
                                  _vm.fields.shippingAddress
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.shippingAddress,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.fields.shippingAddress.error
                            ? _c("span", [
                                _vm._v("Gelieve een adres in te geven.")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "form-group",
                          class: { error: _vm.fields.invoice.error }
                        },
                        [
                          _vm._m(15),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fields.invoice.val,
                                  expression: "fields.invoice.val"
                                }
                              ],
                              attrs: {
                                hidden: "",
                                id: "input-invoice-true",
                                name: "invoice",
                                type: "radio",
                                value: "yes"
                              },
                              domProps: {
                                checked: _vm._q(_vm.fields.invoice.val, "yes")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(
                                      _vm.fields.invoice,
                                      "val",
                                      "yes"
                                    )
                                  },
                                  function($event) {
                                    return _vm.checkErrorChk(_vm.fields.invoice)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "input-invoice-true" } },
                              [_vm._v("Ja")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "checkbox" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.fields.invoice.val,
                                  expression: "fields.invoice.val"
                                }
                              ],
                              attrs: {
                                hidden: "",
                                id: "input-invoice-false",
                                name: "invoice",
                                type: "radio",
                                value: "no"
                              },
                              domProps: {
                                checked: _vm._q(_vm.fields.invoice.val, "no")
                              },
                              on: {
                                change: [
                                  function($event) {
                                    return _vm.$set(
                                      _vm.fields.invoice,
                                      "val",
                                      "no"
                                    )
                                  },
                                  function($event) {
                                    return _vm.checkErrorChk(_vm.fields.invoice)
                                  }
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              { attrs: { for: "input-invoice-false" } },
                              [_vm._v("Nee")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.fields.invoice.error
                            ? _c("span", [
                                _vm._v("Gelieve een antwoord aan te duiden.")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.fields.invoice.val == "yes",
                              expression: "fields.invoice.val == 'yes'"
                            }
                          ],
                          staticClass: "form-group",
                          class: { error: _vm.fields.invoicingAddress.error }
                        },
                        [
                          _vm._m(16),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.invoicingAddress.val,
                                expression: "fields.invoicingAddress.val"
                              }
                            ],
                            attrs: {
                              id: "input-invoicing-address",
                              name: "invoicingAddress",
                              rows: "3"
                            },
                            domProps: {
                              value: _vm.fields.invoicingAddress.val
                            },
                            on: {
                              keyup: function($event) {
                                return _vm.checkErrorReq(
                                  _vm.fields.invoicingAddress
                                )
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.invoicingAddress,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.fields.invoicingAddress.error
                            ? _c("span", [
                                _vm._v("Gelieve een adres in te geven.")
                              ])
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.fields.invoice.val == "yes",
                              expression: "fields.invoice.val == 'yes'"
                            }
                          ],
                          staticClass: "form-group"
                        },
                        [
                          _c(
                            "label",
                            { attrs: { for: "input-invoicing-data" } },
                            [
                              _vm._v(
                                "Welke extra gegevens moeten er nog op de factuur komen? vb. bestelbonnummer."
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.fields.extraDataInvoice.val,
                                expression: "fields.extraDataInvoice.val"
                              }
                            ],
                            attrs: {
                              id: "input-invoicing-data",
                              name: "extraDataInvoice",
                              rows: "3"
                            },
                            domProps: {
                              value: _vm.fields.extraDataInvoice.val
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.fields.extraDataInvoice,
                                  "val",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "swiper-slider__btn-row" }, [
                    _c("span", [
                      _vm._v(
                        "Stap " +
                          _vm._s(_vm.slide) +
                          "/" +
                          _vm._s(_vm.totalSlides)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn--rose",
                          attrs: { type: "button" },
                          on: { click: _vm.prevSlide }
                        },
                        [_vm._v("Terug")]
                      ),
                      _vm._v(" "),
                      _vm.newEntry
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--green",
                              attrs: { type: "button" },
                              on: { click: _vm.nextSlide }
                            },
                            [_vm._v("Volgende")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.newEntry
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn--green",
                              attrs: { type: "submit" }
                            },
                            [_vm._v("Verzenden")]
                          )
                        : _vm._e()
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _vm.newEntry
                ? _c("div", { staticClass: "swiper-slide" }, [
                    _c(
                      "h3",
                      [
                        _vm._t("step5-title", [
                          _vm._v("Nog vragen of onduidelijkheden?")
                        ])
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "rte mb-6" },
                      [_vm._t("step5-text", [_vm._m(17)])],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "input-remarks" } }, [
                        _vm._v("Jouw vragen of opmerkingen")
                      ]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.fields.remarks.val,
                            expression: "fields.remarks.val"
                          }
                        ],
                        attrs: {
                          id: "input-remarks",
                          name: "remarks",
                          rows: "8"
                        },
                        domProps: { value: _vm.fields.remarks.val },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.fields.remarks,
                              "val",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "swiper-slider__btn-row" }, [
                      _c("span", [
                        _vm._v(
                          "Stap " +
                            _vm._s(_vm.slide) +
                            "/" +
                            _vm._s(_vm.totalSlides)
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--rose",
                            attrs: { type: "button" },
                            on: { click: _vm.prevSlide }
                          },
                          [_vm._v("Terug")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn--green",
                            attrs: {
                              type: "submit",
                              disabled: this.disableSubmit
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !this.disableSubmit,
                                    expression: "!this.disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Verzenden")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: this.disableSubmit,
                                    expression: "this.disableSubmit"
                                  }
                                ]
                              },
                              [_vm._v("Even geduld")]
                            )
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "swiper-slide" }, [
                _c(
                  "h3",
                  [_vm._t("step6-title", [_vm._v("Evenement geregistreerd")])],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "rte mb-6" },
                  [_vm._t("step6-text", [_c("p", [_vm._v("Bedankt!")])])],
                  2
                )
              ])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-first-name-contact" } }, [
      _vm._v("Voornaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-last-name-contact" } }, [
      _vm._v("Familienaam "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-job-title-contact" } }, [
      _vm._v("Functie "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-email-contact" } }, [
      _vm._v("E-mailadres "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-city" } }, [
      _vm._v("Gemeente of stad waar je Reveil wil brengen "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-zipcode" } }, [
      _vm._v("Postcode "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-date-start" } }, [
      _vm._v("Datum "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-name" } }, [
      _vm._v(
        "Naam van de locatie van je troostinitiatief (bv. café Den Dreupel, begraafplaats Deerlijk, troostplek Dilbeek…) "
      ),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-street" } }, [
      _vm._v("Straat "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-zipcode" } }, [
      _vm._v("Postcode "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-location-city" } }, [
      _vm._v("Gemeente of stad "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-0" }, [
      _vm._v(
        "\n                                Hoe ziet de programmatie er uit? Welke artiesten / dichters / vertellers komen een eerbetoon brengen op de begraafplaats?"
      ),
      _c("br"),
      _vm._v(
        "\n                                Pas op: jouw info verschijnt onbewerkt op de website.\n                            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("small", [
      _vm._v("Vergeet "),
      _c("em", [_vm._v("http://")]),
      _vm._v(" niet!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Registreer je een troostconcert of een Radio Reveil Café? "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-shipping-address" } }, [
      _vm._v("Naar welk adres mogen we jouw bestelling verzenden? "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [
      _vm._v("Wens je een factuur? "),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "input-invoicing-address" } }, [
      _vm._v(
        "Op welk adres mag de factuur staan? (factuur wordt via pdf bezorgd via mail) "
      ),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Aarzel niet om "),
      _c("a", { attrs: { href: "/contact" } }, [_vm._v("ons te contacteren")]),
      _vm._v(" of hieronder jouw specifieke vraag neer te schrijven."),
      _c("br"),
      _vm._v("We kijken alvast heel erg uit naar jullie aanpak.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }